import { Scenario } from '../models/scenario.model';

/** Upgrade question-linked legacy help steps in place; retain steps used by other paths. */
export function attachScenarioCoaching(scenario: Scenario): void {
  const attached = new Set<string>();
  scenario.steps.forEach(step => {
    if (step.type !== 'question' || step.coaching || !step.onIncorrect) { return; }
    const help = scenario.steps.find(candidate => candidate.id === step.onIncorrect && candidate.type === 'remediation');
    if (!help || !help.next) { return; }
    step.coaching = {
      text: help.body || help.title, after: help.next === step.id ? 'retry' : 'continue', title: help.title,
      ...(help.imageUrl ? { imageUrl: help.imageUrl } : {}),
      ...(help.imageAlt ? { imageAlt: help.imageAlt } : {}),
      ...(help.imagePrompt ? { imagePrompt: help.imagePrompt } : {}),
    };
    if (!step.next) { step.next = step.onCorrect; }
    // A continue route can have its own destination; do not flatten authored branches.
    if (help.next === step.id) { delete step.onIncorrect; } else { step.onIncorrect = help.next; }
    attached.add(help.id);
  });
  if (!attached.size) { return; }
  const referenced = new Set<string>();
  if (scenario.steps[0]) { referenced.add(scenario.steps[0].id); }
  scenario.steps.filter(step => !attached.has(step.id)).forEach(step => {
    [step.next, step.onCorrect, step.onIncorrect].forEach(id => { if (id) { referenced.add(id); } });
  });
  // Keep any legacy chain still reachable from a non-question path, including its content/media.
  const retain = (id: string): void => {
    const step = scenario.steps.find(candidate => candidate.id === id);
    if (!step) { return; }
    [step.next, step.onCorrect, step.onIncorrect].forEach(next => {
      if (next && !referenced.has(next)) { referenced.add(next); retain(next); }
    });
  };
  [...referenced].forEach(retain);
  scenario.steps = scenario.steps.filter(step => !attached.has(step.id) || referenced.has(step.id));
}
